<template>
  <div style="padding-bottom: 43px;">
    <div class="cate">
      <div class="cate_police">
        <div class="cate-all">资源格式：</div>
        <div class="subject">
          <span
            v-for="(item, index) in ResourceFormats"
            :key="index"
            :class="{heightlight : ResourceFormatsindex==index}"
            @click="ResourceFormatsArea(index,item)"
          >{{ item }}</span>
        </div>
      </div>
      <!-- <div class="cate_police">
        <div class="cate-all">资源类型：</div>
        <div class="subject">
          <span
            v-for="(item, index) in ResourceCategories"
            :key="index"
            :class="{heightlight : Resourceindex==index}"
            @click="ResourceArea(index,item)"
          >{{ item.name }}</span>
        </div>
      </div> -->
      <div class="cate_police">
        <div class="cate-all">全部警种：</div>
        <div ref="jzlistobjer" :class='["subject", jzlist&&putaway ? "hiddenlist" : ""]'>
          <span
            v-for="(item, index) in policeClassification"
            :key="index"
            :class="{heightlight : policeClassindex==index}"
            @click="policeClassArea(index,item)"
          >{{ item.name }}</span>
          <div v-if="jzlist&&putaway" class="showlist" @click="()=>{putaway = !putaway}">
            <span>更多</span>
            <i class="el-icon-caret-bottom"></i>
          </div>
          <div v-if="jzlist&&!putaway" class="showlist" @click="()=>{putaway = !putaway}">
            <span>收起</span>
            <i class="el-icon-caret-top"></i>
          </div>
        </div>
      </div>
      <div class="cate_police">
        <div class="cate-all">地市/州 ：</div>
        <div ref="cityobjer" :class='["subject", cityers&&cityputaway ? "hiddenlist" : ""]'>
          <span
            v-for="(item, index) in cityList"
            :key="index"
            :class="{heightlight : cityIndex==index}"
            @click="selectCity(index,item)"
          >{{ item.name }}</span>
          <div v-if="cityers&&cityputaway" class="showlist" @click="()=>{cityputaway = !cityputaway}">
            <span>更多</span>
            <i class="el-icon-caret-bottom"></i>
          </div>
          <div v-if="cityers&&!cityputaway" class="showlist" @click="()=>{cityputaway = !cityputaway}">
            <span>收起</span>
            <i class="el-icon-caret-top"></i>
          </div>
        </div>
      </div>
      <div
        class="cate_police"
        style="border-top: 1px solid #dcdfe6;margin-left: 86px;padding-top: 24px;display: flex;align-items: center;"
      >
        <!-- <div class="cate-all" ></div> -->
        <div class="subject" style="padding-right: 30px;">
          <span
            v-for="(item, index) in newList"
            :key="index"
            style="margin-bottom: 0px;"
            :class="{heightlight : newIndex==index}"
            @click="policeNew(index,item)"
          >{{item.name}}</span>
        </div>
        <el-input
          @keyup.enter.native="init"
          size="large"
          placeholder="请输入搜索内容"
          v-model="listQuerys.Name"
          class="input-with-select"
          style="width:287px;height:40px;font-size: 16px;border-radius:4px;flex-shrink: 0;"
        >
          <el-button
            @click="init()"
            slot="append"
            icon="el-icon-search"
            style="background:#51565C;border-radius: 0px;height: 100%;color:white;font-size:16px;"
          ></el-button>
        </el-input>
      </div>
    </div>

    <!-- 内容 -->
    <div class="box">
      <!-- 视频库 -->
      <div class="leftbox">
        <div class="leftboxmatter">
          <div class="body-small">
            <div class="headmatter">资源分类</div>
            <TreeTest @btnKeyst="btnKeyst"></TreeTest>
          </div>
        </div>
        <div v-if="user.length!==0" class="rightboxmatter" style="width:646px">
          <div v-for="(item,index) in user" :key="index">
            <div class="videoBox" >
              <div class="videoBoximg">
                <div @click="videolearn(index,item)" style="cursor: pointer;">
                  <img :src="item.imgUrl" v-if="item.imgUrl!=''" style="height:95px" />
                </div>
              </div>
              <div class="videoData">
                <div :title="item.name" class="videoDatatop">
                  <span
                    @click="videolearn(index,item)"
                    class="titlename"
                    style="cursor: pointer;"
                    v-html="item.name"
                  ></span>
                  <!-- <span v-if="item.documentType==1">文段</span>
                  <span v-else>视频</span>-->
                </div>
                <div class="videoDatacenter">
                  <span>警种：{{item.jzDicName}}</span>
                  <span>|</span>
                  <span>来源：{{item.deptName}}</span>
                  <span>|</span>
                  <span>发布：{{item.publishTime?item.publishTime.substring(0, 10):item.publishTime}}</span>
                </div>
                <div class="videoDatafoot">
                  <div class="videoDatafootli">
                    <img
                      src="@/assets/videoimg/studycommentylActive.svg"
                      alt
                      style="width:16px;height:16px"
                    />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="'观看数量'+':'+item.visitNum"
                      placement="top"
                    >
                      <span
                        style="font-size:12px;color:#666666;padding-left:2px"
                      >{{item.visitNum}}</span>
                    </el-tooltip>
                  </div>
                  <div class="videoDatafootli">
                    <img
                      src="@/assets/videoimg/studycommentPlin.svg"
                      alt
                      style="width:16px;height:16px"
                    />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="'评论数量'+':'+item.talkCount"
                      placement="top"
                    >
                      <span
                        style="font-size:12px;color:#666666;padding-left:2px"
                      >{{item.talkCount}}</span>
                    </el-tooltip>
                  </div>
                  <div class="videoDatafootli">
                    <!-- <span> -->
                    <img src="@/assets/videoimg/like.svg" alt style="width:12px;height:12px" />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="'点赞数量'+':'+item.assistCount"
                      placement="top"
                    >
                      <span
                        style="font-size:12px;color:#666666;padding-left:2px"
                      >{{item.assistCount}}</span>
                    </el-tooltip>
                    <!-- </span> -->
                  </div>
                  <div class="videoAppraise">
                    评分：<el-rate style="padding-left: 5px;" v-model="item.grade" disabled disabled-void-color="#cccccc"></el-rate>
                  </div>
                </div>
              </div>
            </div>
            <div class="horizontal"></div>
          </div>
          <div class="pageblock">
            <el-pagination
            v-if="dataCount>0"
            background
            prev-text="上一页"
            next-text="下一页"
            layout="total,prev, pager, next,jumper"
            :page-size="listQuerys.Limit"
            :current-page.sync="listQuerys.Page"
            :total="dataCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            ></el-pagination>
          </div>
        </div>
        <div v-else style="margin-top:20px;width:646px">
          <nodata></nodata>
        </div>
      </div>

      <div class="rightbox">
        <!-- 流量排行榜 -->
        <div class="rightboxtop">
          <div class="flowheader">
            <div>热门资源排行</div>
          </div>
          <div class="flowmatter">
            <div class="flowsort" v-for="(item,index) in hotziyuanData" :key="index">
              <div v-if="index<10">{{index+1}}</div>
              <div :title="item.name" class="flowname" v-if="index<10" @click="flowGOto(item)">{{item.name}}</div>
              <div class="flowcnt" v-if="index<10">{{item.cnt}}热度</div>
            </div>
          </div>
        </div>
        <!-- 地市排行榜 -->
        <div class="rightboxfoot">
          <div class="cityheader">
            <div>警种资源排行</div>
          </div>
          <div class="flowmatter">
            <div class="flowsort" v-for="(item,index) in jingzhongData" :key="index">
              <div v-if="index<12">{{index+1}}</div>
              <div v-if="index<12">{{item.name}}</div>
              <div class="flowcnt" v-if="index<12">{{item.cnt}}热度</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TreeTest from './component/treeTest';
import { getCity } from '@/api/public.js';
import * as resourceInfo from '@/api/resources/index.js';
import vHeader from '../header/index';
import linecom from '@/components/linecom/index';
export default {
  components: {
    vHeader,
    linecom,
    TreeTest
  },
  data() {
    return {
      cityList: [{ name: '全部', id: 0 }],
      cityIndex: 0,
      newList: [
        { subType: 0, name: '最新' },
        { subType: 1, name: '最热' },
      ],
      newIndex: 0,
      pSrc: '',
      policeClassification: [{ name: '全部', id: 0 }], //全部警种
      policeClassindex: 0, //高亮默认为全部
      ResourceCategories: [{ name: '全部', id: 0 }], //资源类别
      Resourceindex: 0, //高亮默认为全部
      ResourceFormats: ['全部', '文档', '视频', '图片', '音频'], //资源格式
      ResourceFormatsindex: 0, //高亮默认为全部
      sortType: null, //判断数组中要对哪个值进行排序（最新则对时间进行排序，最热对点赞数进行排序）
      //热门资源
      hotziyuanData: [],
      //警种排行
      jingzhongData: [],
      dataCount: 0,
      listQuery: {
        // 查询字典条件
        page: 1,
        limit: 30,
        key: null,
        namespaceId: null,
      },
      listQuerys: {
        // 查询字典条件
        Page: 1,
        Limit: 8,
        Key: null,
        JzDicId: null,
        ClassDicId: null,
        DocumentType: null,
        Name: null,
        State: 1, //审核通过的显示在前端页面
        IsStop: false,
        sortType: 0,
      },
      user: [], //分页数组
      bbb: [],
      jzlist: false,
      putaway: true,
      cityers: false,
      cityputaway: true,
      treedate: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  created() {
   
    this.getPmiDictionary(1, this.policeClassification);
    // this.getPmiDictionary(51, this.ResourceCategories);
    this.DocumentHotTongJi();
    this.DocumentJzTongJi();
    this.getDishi();
  },
  mounted() {
    // //返回页面调取第几页，调用时必须在init（）方法之前，之后则无效，
    this.listQuerys.Page = Number(localStorage.getItem('currpage')) || 1;
    localStorage.removeItem('currpage');
    this.init();
  },
  methods: {
    allTree() {
      this.listQuerys.ClassDicId = null;
      this.init();
    },
    btnKeyst(id,data={id:0}) {
      if (data.id == 0) {
        this.listQuerys.ClassDicId = null;
      } else {
        this.listQuerys.ClassDicId = id;
      }
      this.init();
    },    
    //查询新热
    policeNew(index, item) {
      this.listQuerys.sortType = item.subType;
      this.listQuerys.Page = 1;
      this.newIndex = index;
      this.init();
    },
    // 全部警种高亮索引判断
    policeClassArea(index, item) {
      this.policeClassindex = index;
      if (item.id == 0) {
        this.listQuerys.JzDicId = null;
      } else {
        this.listQuerys.JzDicId = item.id;
      }
      this.init();
    },
    // 资源类别高亮索引判断
    ResourceArea(index, item) {
      this.Resourceindex = index;
      if (item.id == 0) {
        this.listQuerys.ClassDicId = null;
      } else {
        this.listQuerys.ClassDicId = item.id;
      }
      this.init();
    },
    // 资源格式高亮索引判断
    ResourceFormatsArea(index, item) {
      this.ResourceFormatsindex = index;

      if (index == 0) {
        this.listQuerys.DocumentType = null;
      } else if (index == 1) {
        this.listQuerys.DocumentType = 1;
      } else if (index == 2) {
        this.listQuerys.DocumentType = 2;
      } else if (index == 3) {
        this.listQuerys.DocumentType = 3;
      } else if (index == 4) {
        this.listQuerys.DocumentType = 4;
      }
      this.init();
    },
    //查询地市
    selectCity(index, item) {
      this.cityIndex = index;
    },
    //获取地市
    getDishi() {
      getCity().then((res) => {
        res.result.forEach((e) => {
          this.cityList.push({ name: e.name, id: e.id });
        });
        this.$nextTick(()=>{
          if(this.$refs.cityobjer.clientHeight > 42){
              this.cityers = true
            }
        })
      });
    },
    //获取字典数据  index代表namespaceId，arr代表传出的数组
    getPmiDictionary(index, arr) {
      this.listQuery.namespaceId = index;
      resourceInfo
        .getPmiDic(this.listQuery)
        .then((response) => {
          response.result.forEach((e) => {
            arr.push({ name: e.name, id: e.id });
          });
          this.$nextTick(()=>{
            if(this.$refs.jzlistobjer.clientHeight > 42){
              this.jzlist = true
            }
          })
        })
    },

    flowGOto(item) {
      resourceInfo.DocumentRead(item.documentId).then((res) => {});
      this.$router.push({
        path: '/sourceslist/videoLearn',
        query: {
          id: item.documentId,
        },
      });
      //跳转路由时记录当前为哪一页，返回时调取数据保留在当前页
      localStorage.setItem('currpage', this.listQuerys.Page);
    },
    //模拟请求ajax将数据分页渲染
    init() {
      resourceInfo.getDocumentLoad(this.listQuerys).then((response) => {
        console.log(response);
        this.dataCount = response.count;
        let list = response.data;
        this.changeColor(list);
      });
    },
    changeColor(resultsList) {
      // resultsList全部数据，改变title里的高亮颜色，用正则先去匹配全局匹配到，然后用字符串的替换将原来的title替换需要高亮的部分
      resultsList.map((item, index) => {
        // console.log('item', item)
        if (this.listQuerys.Name && this.listQuerys.Name.length > 0) {
          // 匹配关键字正则
          let replaceReg = new RegExp(this.listQuerys.Name, 'gi');
          // 高亮替换v-html值
          let replaceString =
            '<span class="search-text" style="color:red;">' +
            this.listQuerys.Name +
            '</span>';
          resultsList[index].name = item.name.replace(
            replaceReg,
            replaceString
          );
        }
      });

      this.user = [];
      this.user = resultsList;
    },
    DocumentHotTongJi() {
      resourceInfo.DocumentHotTongJi().then((res) => {
        this.hotziyuanData = res.result;
      });
    },
    DocumentJzTongJi() {
      resourceInfo.DocumentJzTongJi().then((res) => {
        this.jingzhongData = res.result;
      });
    },
    handleSizeChange(val) {
      this.listQuerys.Limit = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.listQuerys.Page = val;
      this.init();
    },

    //点击跳转路由页面
    videolearn(index, item) {
      // console.log(item)
      resourceInfo.DocumentRead(item.id).then((res) => {});
      this.$router.push({
        path: '/sourceslist/videoLearn',
        query: {
          id: item.id,
        },
      });
      //跳转路由时记录当前为哪一页，返回时调取数据保留在当前页
      localStorage.setItem('currpage', this.listQuerys.Page);
      // console.log(this.user[index].id)
      // console.log(this.listQuerys.Page);
    },
  },
};
</script>

<style scoped>
.nav {
  width: 1200px;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  margin: 0 auto;
  margin-top: 10px;
}
.nav > div {
  font-size: 19px;
  margin-left: 32px;
  padding-top: 0px;
}
.navpolice {
  font-size: 19px;
  margin-left: 32px;
  padding-top: 5px;
  display: flex;
}
.navpolice > div:nth-child(1) {
  flex: 1;
}
.navpolice > div:nth-child(2) {
  flex: 11;
}
.navpolice > div {
  margin-bottom: 5px;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.navpolice > div > div {
  line-height: 33px;
  font-size: 16px;
  color: #333333;
  margin-left: 20px;
  margin-top: 10px;
  background: #ececec;
  opacity: 1;
  border-radius: 6px;
  padding-left: 10px;
  padding-right: 10px;
}
/* 高亮 */
.heightlight {
  background-color: #649FED !important;
  color: #f8fafc !important;
}
/* 资源管理内容 */
.box {
  margin: 0 auto;
  width: 1200px;
  margin-top: 14px;
  display: flex;
  justify-content: space-between;
  padding: 21px 14px 0px 14px;
  box-sizing: border-box;
  background: linear-gradient(to bottom, #97CAF4 0%,#fff 300px,#fff 100%);
  border-radius: 4px;
}
.leftboxmatter{
  width: 200px;
  display:inline-block;
}

.body-small{
  height:calc(100% - 26px);
  overflow:auto;
  border:none;
  width:200px;
  border-right: 1px solid #D9D9D9;
  border-radius: 0px;
  margin-top: 26px;
}

/* 左盒子是视频 */
.leftbox {
  width: 846px;
  height: 1102px;
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
}
/* 头部是全部最新最热三个标签 */
.leftbox > .leftboxheader {
  width: 880px;
  height: 46px;
  background: #ebf1f5;
  opacity: 1;
  border-radius: 6px 6px 0px 0px;
  line-height: 46px;
}
.leftbox > .leftboxheader > span {
  width: 58px;
  height: 28px;
  background: #f8fafc;
  opacity: 1;
  border-radius: 6px;
  padding-left: 12px;
  padding-top: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
  margin-left: 22px;
}

.rightboxmatter{
  padding-top: 10px;
}

/* 循环出的视频整个盒子 */
.videoBox {
  display: flex;
  height: 127px;
  box-sizing: border-box;
  padding: 16px 26px;
}
/* 左图片区域 */
.videoBoximg {
  width: 145px;
  flex-shrink: 0;
  margin-right: 25px;
}
.videoBoximg > div {
  width: 145px;
  text-align: center;
}
.videoBoximg > div > img{
  max-width: 145px;
  border-radius: 2px;
}
/* 中间数据部分，样式过多 */
.videoData {
  width: 100%;
}
/* 中上 */
.videoDatatop {
  margin-bottom: 10px;
}
.videoDatatop > span:nth-child(1) {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  opacity: 1;
  display: inline-block;
  max-width: 380px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.titlename:hover {
  color: #1492ff;
}

/* 中中 */
.videoDatacenter {
  font-size: 12px;
  color: #666666;
  line-height: 18px;
  font-weight: 400;
  margin-bottom: 15px;
}
.videoDatacenter > span:nth-child(1) {
  
}
.videoDatacenter > span:nth-child(2),
.videoDatacenter > span:nth-child(4) {
  display: inline-block;
  margin: 0px 5px;
}
.videoDatacenter > span:nth-child(3),
.videoDatacenter > span:nth-child(5) {
  opacity: 1;
}
/* 中下 */
.videoDatafoot {
  display: flex;
  width: 300px;
}
.videoDatafoot > div > span > img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.videoDatafoot > div {
  flex-shrink: 0;
  min-width: 40px;
  padding-right: 15px;
}
.videoDatafootli {
  display: flex;
  align-items: center;
}
/* 视频数据右边评价部分 */
.videoAppraise {
  width: 210px;
  position: relative;
  color: #666666;
  font-size: 12px;
}
.videoAppraise > div:nth-child(1) {
  display: flex;
  position: absolute;
  top: 0;
  margin-left: 40px;
}
/* 水平线 */
.horizontal {
  width: calc(100% - 64px);
  margin-left: 26px;
  height: 0px;
  border: 1px dashed #f2f2f2;
}
/* 分页 样式*/
.pageblock {
  margin-top: 16px;
  text-align: center;
}
/* 右边两模块 */
.rightbox {
  width: 303px;
  height: 1100px;
  /* margin-left: 20px; */
}
/* 浏览量 */
.rightboxtop {
  box-sizing: border-box;
  min-height: 390px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
  padding: 19px 15px 0px 15px;
}
.flowheader {
  width: 100%;
  margin-bottom: 13px;
}
.flowheader > div:nth-child(1) {
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  color: #4D515A;
}

.flowmatter > .flowsort {
  vertical-align: middle;
  display: flex;
}
/* 每一行的间距 */
.flowsort {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.flowname {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.flowname:hover {
  color: #1492ff !important;
}
.flowcnt {
  flex-shrink: 0;
  min-width: 40px;
  text-align: center;
  margin-left: 29px;
  font-size: 12px;
  line-height: 18px;
  color: #7D899D;
}
/* 序号1的样式插入图片 */
.flowmatter > .flowsort:nth-child(1) > div:nth-child(1) {
  height: 18px;
  width: 18px;
  vertical-align: middle;
  background-color: #FFE8E3;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FF7070;
  border-radius: 3px;
  font-weight: bold;
}
/* 所有列表的警种文字样式 */
.flowmatter > .flowsort > div:nth-child(2) {
  margin-left: 7px;
  width: 180px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color:#31303F;
}

/* 序号2的样式插入图片 */
.flowmatter > .flowsort:nth-child(2) > div:nth-child(1) {
  height: 18px;
  width: 18px;
  background-color: #FFEDD2;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FF9255;
  border-radius: 3px;
  font-weight: bold;
}

/* 序号3的样式插入图片 */
.flowmatter > .flowsort:nth-child(3) > div:nth-child(1) {
  height: 18px;
  width: 18px;
  background-color: #FFF4CC;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #F4AD00;
  border-radius: 3px;
  font-weight: bold;
}

/* 大于3的序号样式 */
.flowmatter > .flowsort:nth-child(n + 4) > div:nth-child(1) {
  height: 18px;
  width: 18px;
  background-color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #768297;
  border-radius: 3px;
  font-weight: bold;
}
.flowmatter > .flowsort:nth-child(n + 4) > div:nth-child(1) > div {
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  position: relative;
  top: 2px;
  right: 2px;
  line-height: 27px;
  color: #7D899D;
}
.flowmatter > .flowsort:nth-child(n + 4) > div:nth-child(3) {
  font-size: 12px;
  font-weight: 400;
  line-height: 21px;
}

/* 地市 */
.rightboxfoot {
  margin-top: 12px;
  box-sizing: border-box;
  height: 460px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
  padding: 19px 15px 0px 15px;
}
.cityheader {
  width: 100%;
  margin-bottom: 13px;
}
.cityheader > div:nth-child(1) {
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  color: #4D515A;
}

.cate {
  box-sizing: border-box;
  width: 1200px;
  background: #ffffff;
  margin: 0 auto;
  margin-top: 14px;
  border-radius: 4px;
  padding: 44px 28px 27px 35px;
}
.cate_police {
  display: flex;
  font-size: 16px;
}

.cate_police + .cate_police{
  margin-top: 12px;
}

.cate-all {
  width: 76px;
  font-size: 14px;
  line-height: 21px;
  margin-right: 10px;
}
.subject {
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding-right: 80px;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  height: 22px;
  padding: 0px 10px;
  color: #000;
  opacity: 1;
  border: 1px solid white;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 20px;
}
.subject > span:hover {
  border: 1px solid #649FED;
  color: #649FED;
  border-radius: 4px;
}

/deep/.input-with-select input{
  border-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
/deep/.input-with-select .el-input-group__append{
  border-color: #51565C;
}

.headmatter{
  color: #000;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}
/deep/ .el-card__body{
  padding: 0;
}
/deep/ .el-card{
  border-radius: 10px 0 10px 10px;
}

.subject >.showlist{
  position:absolute;
  z-index: 3;
  right: 0px;
  top: 0px;
  padding-left: 10px;
  cursor: pointer;
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  color: #4D515A;
}
.hiddenlist{
  height: 42px;
}
</style>